var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bookmarks-list-component"},[_c('ul',_vm._l((_vm.$store.getters.bookmarked),function(item,index){return (item)?_c('li',{key:index},[_c('div',{staticClass:"news-wrapper"},[_c('news-single',{attrs:{"item":item,"redirect":false},on:{"close":function($event){return _vm.bookmark(item._id)}}})],1)]):_vm._e()}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }